// extracted by mini-css-extract-plugin
export default {"switch":"switch_f24a83d9b38b32b01be5","thumb":"thumb_bdd4615adfad71d2e493"};